"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/legacy_portal_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyPortalAccountServiceLinkWithFanyIdResponse = exports.LegacyPortalAccountServiceLinkWithFanyIdRequest = exports.LegacyPortalAccountServiceSignInWithFanyIdResponse = exports.LegacyPortalAccountServiceSignInWithFanyIdRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * FANY IDサインイン開始
 *
 * @generated from message spwn.account.v1.LegacyPortalAccountServiceSignInWithFanyIdRequest
 */
class LegacyPortalAccountServiceSignInWithFanyIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * サインイン処理開始前にいたURL
         *
         * @generated from field: string from = 1;
         */
        this.from = "";
        /**
         * サインイン処理を開始したportalのorigin
         *
         * @generated from field: string origin = 2;
         */
        this.origin = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAccountServiceSignInWithFanyIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAccountServiceSignInWithFanyIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAccountServiceSignInWithFanyIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAccountServiceSignInWithFanyIdRequest, a, b);
    }
}
exports.LegacyPortalAccountServiceSignInWithFanyIdRequest = LegacyPortalAccountServiceSignInWithFanyIdRequest;
LegacyPortalAccountServiceSignInWithFanyIdRequest.runtime = protobuf_1.proto3;
LegacyPortalAccountServiceSignInWithFanyIdRequest.typeName = "spwn.account.v1.LegacyPortalAccountServiceSignInWithFanyIdRequest";
LegacyPortalAccountServiceSignInWithFanyIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "origin", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.LegacyPortalAccountServiceSignInWithFanyIdResponse
 */
class LegacyPortalAccountServiceSignInWithFanyIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * FANY IDサードパーティログインURL
         *
         * @generated from field: string url = 1;
         */
        this.url = "";
        /**
         * `param`パラメータの値 (サードパーティログインに必要な値を暗号化した文字列)
         *
         * @generated from field: string param = 2;
         */
        this.param = "";
        /**
         * `site`パラメータの値 (サイトID)
         *
         * @generated from field: string site_id = 3;
         */
        this.siteId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAccountServiceSignInWithFanyIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAccountServiceSignInWithFanyIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAccountServiceSignInWithFanyIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAccountServiceSignInWithFanyIdResponse, a, b);
    }
}
exports.LegacyPortalAccountServiceSignInWithFanyIdResponse = LegacyPortalAccountServiceSignInWithFanyIdResponse;
LegacyPortalAccountServiceSignInWithFanyIdResponse.runtime = protobuf_1.proto3;
LegacyPortalAccountServiceSignInWithFanyIdResponse.typeName = "spwn.account.v1.LegacyPortalAccountServiceSignInWithFanyIdResponse";
LegacyPortalAccountServiceSignInWithFanyIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "param", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * FANY ID連携開始
 *
 * @generated from message spwn.account.v1.LegacyPortalAccountServiceLinkWithFanyIdRequest
 */
class LegacyPortalAccountServiceLinkWithFanyIdRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 連携処理を開始したportalのorigin
         *
         * @generated from field: string origin = 1;
         */
        this.origin = "";
        /**
         * 表示名
         *
         * @generated from field: string display_name = 2;
         */
        this.displayName = "";
        /**
         * email
         *
         * @generated from field: string email = 3;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAccountServiceLinkWithFanyIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAccountServiceLinkWithFanyIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAccountServiceLinkWithFanyIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAccountServiceLinkWithFanyIdRequest, a, b);
    }
}
exports.LegacyPortalAccountServiceLinkWithFanyIdRequest = LegacyPortalAccountServiceLinkWithFanyIdRequest;
LegacyPortalAccountServiceLinkWithFanyIdRequest.runtime = protobuf_1.proto3;
LegacyPortalAccountServiceLinkWithFanyIdRequest.typeName = "spwn.account.v1.LegacyPortalAccountServiceLinkWithFanyIdRequest";
LegacyPortalAccountServiceLinkWithFanyIdRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "origin", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.LegacyPortalAccountServiceLinkWithFanyIdResponse
 */
class LegacyPortalAccountServiceLinkWithFanyIdResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * FANY IDサードパーティログインURL
         *
         * @generated from field: string url = 1;
         */
        this.url = "";
        /**
         * `param`パラメータの値 (サードパーティログインに必要な値を暗号化した文字列)
         *
         * @generated from field: string param = 2;
         */
        this.param = "";
        /**
         * `site`パラメータの値 (サイトID)
         *
         * @generated from field: string site_id = 3;
         */
        this.siteId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalAccountServiceLinkWithFanyIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalAccountServiceLinkWithFanyIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalAccountServiceLinkWithFanyIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(LegacyPortalAccountServiceLinkWithFanyIdResponse, a, b);
    }
}
exports.LegacyPortalAccountServiceLinkWithFanyIdResponse = LegacyPortalAccountServiceLinkWithFanyIdResponse;
LegacyPortalAccountServiceLinkWithFanyIdResponse.runtime = protobuf_1.proto3;
LegacyPortalAccountServiceLinkWithFanyIdResponse.typeName = "spwn.account.v1.LegacyPortalAccountServiceLinkWithFanyIdResponse";
LegacyPortalAccountServiceLinkWithFanyIdResponse.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "param", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=legacy_portal_service_pb.js.map